import { library, IconName } from '@fortawesome/fontawesome-svg-core';

import {
  faQuestionCircle,
  faCog,
  faDatabase,
  faSignOutAlt,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faArrowCircleUp,
  faSearch,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCalendar,
  faInfoCircle,
  faFileExport,
  faShareSquare,
  faCheckCircle,
  faTrashAlt,
  faSyncAlt,
  faExclamationCircle,
  faTimesCircle,
  faComment,
  faBell,
  faArchive,
  faEyeSlash,
  faFileCsv,
  faSort,
  faEnvelope,
  faEnvelopeOpenText
} from '@fortawesome/free-solid-svg-icons';

import {
  faFile,
  faFileImage,
  faFileWord,
  faFileExcel,
  faFilePdf
} from '@fortawesome/free-regular-svg-icons';

library.add(
  faQuestionCircle,
  faCog,
  faDatabase,
  faSignOutAlt,
  faArrowAltCircleUp,
  faArrowAltCircleDown,
  faArrowCircleUp,
  faSearch,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCalendar,
  faInfoCircle,
  faFileExport,
  faShareSquare,
  faCheckCircle,
  faTrashAlt,
  faSyncAlt,
  faExclamationCircle,
  faFile,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFilePdf,
  faFileCsv,
  faTimesCircle,
  faComment,
  faBell,
  faArchive,
  faEyeSlash,
  faSort,
  faEnvelope,
  faEnvelopeOpenText
);

export const FONTAWESOME_ICON_NAMES: {[key: string]: IconName} = {
  CHEVRON_UP: "chevron-up",
  CHEVRON_DOWN: "chevron-down"
}

export default library;
